import type { ChangeEvent } from "react"
import classnames from "classnames"

export interface CheckboxProps {
  ariaLabel?: string
  checked: boolean
  disabled?: boolean
  id: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  size?: "lg" | "md"
  label: string
}

export const Checkbox = ({
  ariaLabel = undefined,
  checked,
  disabled = false,
  id,
  onChange = undefined,
  size = "md",
  label,
}: CheckboxProps) => {
  return (
    <div className="d-f p-r">
      <input
        type="checkbox"
        id={id}
        aria-label={ariaLabel}
        className={classnames("checkbox", size === "lg" && "large-checkbox")}
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          onChange && onChange(event)
        }}
      />
      <label
        htmlFor={id}
        className={classnames(
          "checkbox-label",
          size === "lg" && "large-checkbox-label",
        )}
      >
        {label}
      </label>
    </div>
  )
}
